export default function calculateScale(): number {
    // const w: number = window.innerWidth
    // if (w > 1733)
        // return 8
        return 8
  
}